module.exports = __webpack_public_path__ + "static/bayin-b1d77f2c6bf25ae5d5fdbe061e4d38c0.png";